import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { constructSeries } from '../../../components/charts/functions'
import { array, bool } from 'prop-types'

const LineChart = ({ postagens }) => {
  const [series, setSeries] = useState([])

  const init = async posts => {
    const series = await constructSeries(posts, 'numeroPaginas')
    setSeries(series)
  }

  useEffect(() => {
    init(postagens)
  }, [postagens])

  const options = {
    chart: {
      series: false,
      type: 'line',
      stacked: false,
      toolbar: {
        show: false
      },
      offsetX: 3
    },
    dataLabels: {
      enabledOnSeries: false,
      enabled: true,
      formatter: function (val) {
        return val
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        padding: 5,
        borderRadius: 8,
        borderWidth: 0,
        opacity: 0.95
      }
    },
    colors: ['#185273'],
    stroke: {
      curve: 'smooth',
      width: 3
    },

    plotOptions: {},
    xaxis: {
      categories: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
      ]
    },
    yaxis: [
      {
        title: {
          text: 'Numero de páginas lidas',
          offsetX: -7,
          style: {
            color: '#185273',
            fontSize: '16px'
          }
        }
      }
    ],
    tooltip: {
      shared: false,
      intersect: true,
      x: {
        show: false
      }
    },
    legend: {
      show: true
    }
  }

  return (
    <div
      style={{
        height: '100%',
        padding: '0.2rem'
      }}
    >
      <Chart
        options={options}
        series={series}
        height="100%"
        style={{ marginTop: '0%' }}
      />
    </div>
  )
}

LineChart.propTypes = {
  postagens: array,
  meta: bool
}

export default LineChart
